/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 06.06.2016.
 */

lmApp.service('OperatorRsc', ['$resource', function ($resource) {

  return $resource('/discovery:80/v2/sotalcloud-operator-registry/2/operators/me/:id',
    null,
    {
      query: {
        method: 'GET',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      update: {
        method: 'PATCH',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      getCurrentOperator: {
        url: '/discovery:80/sdp/v2/operators/me',
        method: 'GET',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      }
    });
}]);